<template>
  <section class="content">
    <h1 v-if="brandName && storeName" style="position: absolute; top: -39px; left: 142px; font-size: 18px;">{{ brandName }} - {{ storeName }}</h1>
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h5><span class="text-red">＊</span> 相同料號的商品會一併新增、修改</h5>
          </div>
          <div class="box-body form">
            <!-- 按鈕群組 - Start -->
            <div class="flex justify-between">
              <div class="flex m-b-10">
                <label for="choose" :class="['btn btn-left', switchType === 'choose' ? 'btn-primary' : 'btn-default']">搜尋商品</label>
                <label for="input" :class="['btn btn-right', switchType === 'input' ? 'btn-primary' : 'btn-default']">{{ !up ? '新增' : '編輯' }}商品</label>
                <input v-show="false" v-model="switchType" type="radio" id="choose" name="type" value="choose">
                <input v-show="false" v-model="switchType" type="radio" id="input" name="type" value="input">
              </div>
              <div class="pull-right m-b-10" v-if="up" style="position: absolute; top: 0; right: 0;" >
                <button class="btn btn-danger inline-block" data-toggle="modal" data-target="#delSmModal"><i class="fa fa-trash"></i></button>
              </div>
            </div>
            <!-- 按鈕群組 - End -->
            <div>
              <div class="input-group" style="max-width: 600px">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>商品名稱
                  <span v-if="$route.name === 'crCategoryImg'"> (分類)</span>
                </span>
                <input v-if="switchType === 'input'" class="form-control" type="text" v-model="product.input.item.name" maxlength="32" style="height: 40px">
                <multiselect
                  v-else
                  @input="checkVenderId()"
                  v-model="product.choose.item"
                  :options="optionsList"
                  :searchable="true"
                  :allow-empty="true"
                  :close-on-select="true"
                  placeholder="請輸入商品名稱"
                  :show-labels="true"
                  :multiple="false"
                  label="name"
                  track-by="id"
                >
                  <template slot="option" slot-scope="props">
                    <span>{{ props.option.name }}</span>
                    <span>({{ props.option.id }})</span>
                  </template>
                </multiselect>
                <!-- <span @click="openChooseProdModal(product_name)" class="c-pointer input-group-addon">
                  <i class="fa fa-search" aria-hidden="true"></i>
                  搜尋商品
                </span> -->
              </div>
              <br />
            </div>
            <div>
              <div class="input-group has-feedback" :class="!up ? product[switchType].isItemCanCreate ? 'has-success' : 'has-error' : ''" style="max-width: 600px">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>商品料號
                  <span v-if="$route.name === 'crCategoryImg'"> (分類)</span>
                </span>
                <input v-if="switchType === 'input'" class="form-control" placeholder="" @focusout="checkVenderId" type="text" v-model="product.input.item.id" maxlength="32" style="height: 40px">
                <multiselect
                  v-else
                  @input="checkVenderId()"
                  v-model="product.choose.item"
                  :options="optionsList"
                  :searchable="true"
                  :allow-empty="true"
                  :close-on-select="true"
                  placeholder="請輸入商品料號"
                  :show-labels="true"
                  :multiple="false"
                  label="id"
                  track-by="id"
                >
                  <template slot="option" slot-scope="props">
                    <span>{{ props.option.name }}</span>
                    <span>({{ props.option.id }})</span>
                  </template>
                </multiselect>
                <span v-if="!up" class="form-control-feedback" :class="product[switchType].isItemCanCreate ? 'fa fa-check' : 'fa fa-times'" aria-hidden="true" style="line-height: 40px"></span>
                <span v-if="!up" id="inputIconStatus" class="sr-only"></span>
              </div>
              <br />
            </div>
            <div>
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>小圖 <br>
                  <span v-if="$route.name !== 'crCategoryImg'">(80x60)</span>
                  <span v-else>(800x210)</span>
                </span>
                <img-update :index="99" :type="1" :imgSrc="smImgSrc" v-if="up"></img-update>
                <img-up-drop id="sm-image" :type="1" :amount="1" :imgList="imgList" v-else></img-up-drop>
              </div>
              <br />
            </div>
            <div  v-if="!up && $route.name !== 'crCategoryImg'">
              <div class="input-group">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>大圖 <br> (800x600)
                </span>
                <img-up-drop id="lg-image" :type="2" :amount="5" :imgList="imgList"></img-up-drop>
              </div>
              <br />
            </div>
            <div v-if="up">
              <div class="input-group" style="max-width: 400px">
                <span class="input-group-addon">
                  <span class="text-red">＊ </span>啟用
                </span>
                <multiselect
                  v-model="is_enabled"
                  :options="enableOption"
                  label="label"
                  :searchable="false"
                  :allow-empty="false"
                  :close-on-select="true"
                  placeholder="啟用"
                  :show-labels="false"
                  :preselect-first="true"
                >
                </multiselect>
              </div>
              <br />
            </div>
            <div class="row form-inline" v-if="elementList.length && this.tab !== 10">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="th-thin">#</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">大圖 (800x600)</th>
                    <!--<th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱</th>-->
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">排序</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">描述</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="" v-if="up">刪除</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(element, index) in elementList">
                    <td class="sorting_1">{{index + 1}}</td>
                    <td>
                      <img-update :index="index" :type="2" :imgSrc="element.img_url" :checkLoading="checkLoading" v-if="up"></img-update>
                      <img :src="element.img_url" :id="'img-load' + index + '-' + type" class="h-auto img-responsive inline-block" v-else>
                    </td>
                    <!--
                    <td>
                      <input class="form-control" v-model="element.name" placeholder="前端不顯示">
                    </td>
                    -->
                    <td>
                      <div class="input-group has-feedback" :class="{'has-error': element.isloading && element.sort === ''}">
                        <input class="form-control" v-model="element.sort" placeholder="數字" aria-describedby="inputError">
                        <span class="form-control-feedback" :class="{'fa fa-times': element.isloading && element.sort === ''}" aria-hidden="true"></span>
                        <span id="inputError" class="sr-only"></span>
                      </div>
                    </td>
                    <td>
                      <textarea style="max-width: 250px; width: 100%" class="form-control" v-model="element.description" placeholder="描述"></textarea>
                    </td>
                    <td v-if="up">
                      <button @click="clickCurrent(element.id, index)" class="btn btn-danger" v-if="element.img_type" data-toggle="modal" data-target="#delModal"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="box-footer text-center">
            <button class="btn btn-fail text-black" @click="$router.go(-1)">
              返回
            </button>
            <button class="btn btn-success" @click="checkImg()" v-if="!up">
              新增
            </button>
            <button class="btn btn-success" @click="checkImg()" v-else>
              更新
            </button>
          </div>
        </div>
      </div>
    </div>
    <m-modal :option="delSmImgOption" @trigger="trigger"></m-modal>
    <m-modal :option="delOption" @trigger="trigger"></m-modal>
    <!-- 隱藏商品搜尋框功能
    <choose-product-modal :openModal.sync="searchModal.open" :option="chooseOption" :search="searchModal.text" @selectedProd="overwriteProduct"></choose-product-modal> -->
  </section>
</template>

<script>
// Require needed datatables modules
import $ from 'jquery'
import bindingTable from './Temp/BindingTable'
import imgUpdateTemp from './Temp/ImgUpdateTemp'
import imgUpdateDropTemp from './Temp/ImgUpdateDropTemp'
import chooseProductModal from '@/components/elements/ChooseProductModal.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    'choose-product-modal': chooseProductModal,
    'binding-table': bindingTable,
    'img-update': imgUpdateTemp,
    'img-up-drop': imgUpdateDropTemp
  },
  data () {
    return {
      brandName: '',
      storeName: '',
      menuState: 4,
      total: 1,
      count: 2,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      elementList: [
        {name: '', img_url: '', sort: '', description: '', file: '', isloading: false},
        {name: '', img_url: '', sort: '', description: '', file: '', isloading: false},
        {name: '', img_url: '', sort: '', description: '', file: '', isloading: false},
        {name: '', img_url: '', sort: '', description: '', file: '', isloading: false},
        {name: '', img_url: '', sort: '', description: '', file: '', isloading: false}
      ],
      is_enabled: {label: '啟用', value: 1},
      product_name: '', // 商品名稱
      vendor_custom_id: '', // 商品料號
      switchType: 'choose', // choose: 搜尋, input: 輸入
      product: {
        input: {
          item: { // 為符合 choose 排版
            name: '',
            id: ''
          },
          isItemCanCreate: false
        },
        choose: { // 搜尋商品選項
          item: {},
          isItemCanCreate: false
        }
      },
      optionsList: [], // 搜尋列表
      addElementList: [],
      addAmount: 5,
      settingId: '',
      type: 1, // 1 = 小圖， 2 = 大圖
      currentId: '',
      smImgSrc: '',
      up: false,
      // chooseOption: {
      //   title: '搜尋商品',
      //   id: 'searchProd'
      // },
      // searchModal: { // 搜尋商品彈窗
      //   text: '', // 搜尋文字
      //   open: false // 開啟
      // },
      enableOption: [
        {label: '啟用', value: 1},
        {label: '停用', value: 0}
      ],
      delOption: {
        id: 'delModal',
        title: '刪除大圖',
        body: '',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delBigImg'
          }
        ]
      },
      delSmImgOption: {
        id: 'delSmModal',
        title: '刪除小圖',
        body: '確定刪除小圖？',
        btns: [
          {
            name: '取消'
          },
          {
            name: '確定',
            event: 'delSmImg'
          }
        ]
      },
      imgList: {
        smImgList: [],
        lgImgList: []
      }
    }
  },
  methods: {
    checkVenderId () {
      // 判斷商品 ID 是否重複
      const id = this.product[this.switchType].item.id
      if (id !== '') {
        var url = 'store/' + this.$route.params.store_id + '/productImageSetting/list?size=1' + '&type=' + this.tab + '&page=1' + '&vendor_custom_id_full=' + id
        this.getDataH('get', url, null, (response) => {
          this.product[this.switchType].isItemCanCreate = response.data.list.length <= 0
        })
      } else {
        this.product[this.switchType].isItemCanCreate = false
      }
    },
    checkLoading (index, isloading) {
      this.elementList[index].isloading = isloading
    },
    trigger (event) {
      if (event === 'delBigImg') {
        this.delBigImg()
      } else if (event === 'delSmImg') {
        this.delSmImg()
      }
    },
    clickCurrent (itemId, index) {
      this.currentId = itemId
      this.delOption.body = '是否刪除第' + (index + 1) + '張大圖？'
    },
    delSmImg () {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.$route.params.setting_id
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.$notify({
            title: '成功',
            text: '圖片刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.$router.push({ path: self.returnPage })
        }
      })
    },
    delBigImg (index) {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.$route.params.setting_id + '/sub/' + this.currentId
      this.getDataH('delete', url, null, function (response) {
        if (response.data.status === 200) {
          self.currentId = ''
          self.$notify({
            title: '成功',
            text: '圖片刪除成功',
            duration: 3000,
            type: 'success',
            width: 400
          })
          self.elementList = [
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false}
          ]
          /*
          if (self.elementList.length - 1 === index) {
            self.$router.push('/brandProductImage/' + self.$route.params.brand_id)
          } else self.getImgSetting()
          */
          self.getImgSetting()
        }
      })
    },
    checkImg () {
      var msg = ''
      if (!this.product[this.switchType].item.id) {
        msg = '請輸入商品料號'
      }

      if (!this.product[this.switchType].item.name && !this.up) {
        msg = '請輸入商品名稱'
      }

      if (!this.imgList.smImgList.length && !this.elementList.length && !this.smImgSrc && !this.up) {
        msg = '請上傳小圖或大圖'
      }

      for (var i = 0; i < this.elementList.length; i++) {
        if (this.elementList[i].sort === '' && this.elementList[i].isloading) {
          msg = '請輸入第' + (i + 1) + '個大圖的順序'
          break
        }
        if (this.elementList[i].sort !== '' && !this.elementList[i].isloading) {
          msg = '請上傳第' + (i + 1) + '個大圖'
        }
      }
      this.getToast(msg)
    },
    getToast (msg) {
      if (msg) {
        this.$notify({
          title: '提醒',
          text: msg,
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        if (this.$route.name.indexOf('ProductImg') > -1) this.crSmallImg(1)
        else if (this.$route.name.indexOf('PackageImg') > -1) this.crSmallImg(3)
        else if (this.$route.name.indexOf('CategoryImg') > -1) this.crSmallImg(10)
        console.log(this.$route.name.indexOf('CategoryImg') > -1)
      }
    },
    crSmallImg (prodType) {
      var self = this
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting'
      if (this.up) url = url + '/' + this.$route.params.setting_id
      var data = new FormData()
      // 商品類型 商品 = 1，套餐 = 3，分類 = 10
      data.append('type', prodType)
      data.append('vendor_custom_id', this.product[this.switchType].item.id)
      data.append('is_enabled', 1)
      data.append('src_id_type', 1)
      data.append('product_name', this.product[this.switchType].item.name)
      if (this.imgList.smImgList.length) data.append('image', this.imgList.smImgList[0].file)
      else if ($('#file-upload-99-1')[0]) {
        if ($('#file-upload-99-1')[0].files[0]) data.append('image', $('#file-upload-99-1')[0].files[0])
      }
      if (this.up) data.append('is_enabled', this.is_enabled.value)
      this.getDataH('post', url, data, function (response) {
        if (response.data.status === 200) {
          if (self.up) self.settingId = self.$route.params.setting_id
          else self.settingId = response.data.setting_id
          if (self.settingId || self.up) self.checkBigImg()
        }
      })
    },
    checkBigImg () {
      var self = this
      var text = '圖片新增成功'
      if (this.elementList.length) {
        for (var i = 0; i < this.elementList.length; i++) {
          if (this.elementList[i].sort) {
            this.crBigImg(i, this.elementList[i])
          } else if (self.elementList.length - 1 === i) {
            if (this.up) text = '圖片更新成功'
            self.$notify({
              title: '成功',
              text: text,
              duration: 3000,
              type: 'success',
              width: 400
            })
            self.$router.go(-1)
          }
        }
      } else {
        if (this.up) text = '圖片更新成功'
        self.$notify({
          title: '成功',
          text: text,
          duration: 3000,
          type: 'success',
          width: 400
        })
        self.$router.push({ path: self.returnPage })
      }
    },
    crBigImg (index, img) {
      var self = this
      let url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.settingId + '/sub'
      if (img.id) url = url + '/' + img.id
      var data = new FormData()
      // 商品類型 商品 = 1，套餐 = 2
      var element = this.elementList[index]
      data.append('description', element.description)
      data.append('sort', element.sort)
      if (this.elementList[index].file) data.append('image', this.elementList[index].file)
      else if ($('#file-upload-' + index + '-2')[0]) {
        if ($('#file-upload-' + index + '-2')[0].files[0]) data.append('image', $('#file-upload-' + index + '-2')[0].files[0])
      }
      this.getDataH('post', url, data, function (response) {
        console.log(response.data)
        if (response.data.status === 200) {
          if (self.elementList.length - 1 === index) {
            var text = '圖片新增成功'
            if (self.up) text = '圖片更新成功'
            self.$notify({
              title: '成功',
              text: text,
              duration: 3000,
              type: 'success',
              width: 400
            })
            console.log(2, self.tab)
            self.$router.push({ path: self.returnPage })
          }
        }
      })
    },
    getImgSetting () {
      var url = 'store/' + this.$route.params.store_id + '/productImageSetting/' + this.$route.params.setting_id
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const res = response.data.setting
          this.product['input'].item.name = res.product_name || ''
          this.product['input'].item.id = res.vendor_custom_id

          // 判斷搜尋下拉中是否有一樣的資料
          const sameOption = this.optionsList.find((item) => {
            return (item.id === res.vendor_custom_id) && (item.name === res.product_name)
          })
          if (sameOption) {
            this.$nextTick(() => {
              this.product['choose'].item = {
                id: res.vendor_custom_id,
                name: res.product_name
              }
            })
          } else {
            this.switchType = 'input'
          }

          this.is_enabled = this.enableOption.find((item) => {
            return item.value === res.is_enabled
          })
          this.elementList = [
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false},
            {name: '', img_url: '', sort: '', description: '', isloading: false}
          ]
          res.sub_image_list.forEach((o, index) => {
            this.elementList[index] = o
            if (this.elementList[index].img_url) {
              this.elementList[index].isloading = true
            } else {
              this.elementList[index].isloading = false
            }
          })
          this.smImgSrc = res.main_image.img_url
          this.is_enabled = this.enableList.find(function (o) { if (o.label === res.is_enabled) return o })
        }
      })
    },
    async getMenuId () {
      // 取得該店 Menu id
      const url = 'onlineMenu/list?page=1&size=1&store_id=' + this.$route.params.store_id
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const result = response.data.menu_list
            ? response.data.menu_list[0]
              ? response.data.menu_list[0].id
              : null
            : null
          if (result) {
            this.getProductInfoList(result)
          } else {
            this.setUpAdd()
          }
        }
      })
    },
    async getProductInfoList (menuId) {
      // 取得該店商品列表 (商品名 + 料號)
      const url = 'onlineMenu/' + menuId + '/productBrief'
      await this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.optionsList = []
          const menu = response.data.brief
          menu.category_list.forEach((category) => {
            if (this.tab === 10) {
              const data = {
                name: category.name,
                id: category.vendor_custom_id
              }
              this.optionsList.push(data)
            } else {
              category.child_list.forEach((prod) => {
                if (prod.type === this.tab) {
                  const data = {
                    name: prod.name,
                    id: prod.vendor_custom_id
                  }
                  this.optionsList.push(data)
                }
              })
            }
          })
        }
      })
      this.setUpAdd()
    },
    setUpAdd () {
      if (this.$route.name.indexOf('up') > -1) {
        this.up = true
        this.getImgSetting()
      } else {
        this.elementList = []
      }
    },
    getStoreInfo () {
      var url = '/store/' + this.$route.params.store_id + '/info'
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          const storeInfo = response.data.info
          this.brandName = storeInfo.brand_name
          this.storeName = storeInfo.name
        }
      })
    }
    // 隱藏商品搜尋框功能
    // openChooseProdModal (name) {
    //   if (name.trim()) {
    //     this.searchModal.text = name.trim()
    //   }
    //   this.searchModal.open = true
    // },
    // overwriteProduct (val) {
    //   // 將選擇的商品，覆蓋名稱與料號輸入框
    //   if (val.length) {
    //     this.product_name = val[0].name
    //     this.vendor_custom_id = val[0].vendor_custom_id
    //     this.checkVenderId()
    //   }
    // }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    tab () {
      var rName = this.$route.name
      switch (rName) {
        case 'crProductImg':
        case 'upProductImg':
          return 1
        case 'crPackageImg':
        case 'upPackageImg':
          return 3
        case 'crCategoryImg':
        case 'upCategoryImg':
          return 10
      }
    },
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    tabNamePlaceholder () {
      switch (this.tab) {
        case 2: return '配料名稱'
        case 20: return '配料群組名稱'
        case 10: return '商品分類名稱'
        case 1: return '商品名稱'
        case 11: return '品項選擇區名稱'
        case 3: return '套餐名稱'
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    },
    returnPage () {
      return `/storeTable/productImage/${this.$route.params.brand_id}/${this.$route.params.store_id}?tab=${this.tab}`
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
    },
    tab () {
    },
    'imgList.lgImgList' () {
      var self = this
      if (this.$route.name.indexOf('up') === -1) {
        this.elementList = []
      }
      this.imgList.lgImgList.forEach(function (lgImg, index) {
        var o = {name: lgImg.name, img_url: lgImg.src, sort: index + 1, description: '', file: lgImg.file, isloading: true}
        self.elementList.push(o)
      })
    }
  },
  async created () {
    await this.getMenuId()
    // 顯示 {品牌名稱 - 門市名稱}
    if (!this.$route.query.brand_name || !this.$route.query.store_name) {
      this.getStoreInfo()
    } else {
      this.brandName = this.$route.query.brand_name
      this.storeName = this.$route.query.store_name
    }
  }
}
</script>
<style lang="sass">
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>
<style lang="sass" scoped>
  table.table-bordered tbody th, table.table-bordered tbody td
    vertical-align: middle
  .btn-left
    border-start-end-radius: 0px
    border-end-end-radius: 0px
  .btn-right
    border-start-start-radius: 0px
    border-end-start-radius: 0px
  .form-control-feedback
    z-index: 0
  .has-error .multiselect
    border-radius: 5px
    border: 1px solid #a94442
  .has-success .multiselect
    border-radius: 5px
    border: 1px solid #3c763d
</style>



// WEBPACK FOOTER //
// CrImgSetting.vue?08406d96